import { UseWizardAction } from "./wizard.actions";
import { WizardActionType, WizardStateOf } from "./wizard.types";

const WizardReducer = <T, TStepMeta>(
    state: WizardStateOf<T, TStepMeta>,
    action: UseWizardAction<T>
): WizardStateOf<T, TStepMeta> => {
    const saveToHistory = (newState: WizardStateOf<T, TStepMeta>) => ({
        ...newState,
        history: [...state.history, state.state]
    });

    const undoToHistory = (currentState: WizardStateOf<T, TStepMeta>) => {
        const newHistory = currentState.history.slice(0, -1);
        const previousState = newHistory[newHistory.length - 1];
        return {
            ...currentState,
            state: previousState,
            history: newHistory
        };
    };

    switch (action.type) {
        case WizardActionType.SetState: {
            const { newState } = action.payload;
            return {
                ...state,
                state: {
                    ...state.state,
                    ...newState
                }
            };
        }
        case WizardActionType.Reset: {
            const { initialState, steps } = action.payload;
            return {
                state: initialState,
                currentStep: 0,
                steps,
                history: [initialState]
            };
        }
        case WizardActionType.NextStep:
            if (state.currentStep >= state.steps.length) return state;
            return saveToHistory({
                ...state,
                currentStep: state.currentStep + 1
            });
        case WizardActionType.PreviousStep:
            if (state.currentStep <= 0) return state;
            return undoToHistory({
                ...state,
                currentStep: state.currentStep - 1
            });
        case WizardActionType.GoToStep: {
            const { step } = action.payload;
            if (
                step < 0 ||
                step > state.steps.length - 1 ||
                step === state.currentStep
            ) {
                return state;
            }

            const stepsToUndo = state.currentStep - step;

            let newState: WizardStateOf<T, TStepMeta> = { ...state };
            for (let i = 0; i < stepsToUndo; i++) {
                newState = undoToHistory({
                    ...newState,
                    currentStep: newState.currentStep - 1
                });
            }
            return {
                ...newState,
                currentStep: step
            };
        }
        default:
            return state;
    }
};

export { WizardReducer };
